import PubSub from 'pubsub-js';
import { watch } from 'vue';
import { acceptorsService } from '@/modules/acceptors';
import {
  printService,
  usePrinterStatusStore,
  TPrintErrorCodes
} from '@/modules/print';
import { userFundsService } from '@/modules/user-funds';

(function () {
  angular.module('7Terminal.Peripherals')
    .service('Peripherals', Peripherals);

  function Peripherals(
    $q,
    $rootScope,
    $log,
    NabNotifications,
    errorParser,
  ) {
    var peripheralsState = {
      connection: {
        valid: true
      },
      printer: {
        valid: true,
        statusLevel: 'OK',
        errorMessage: ''
      },
      moneyAcceptors: {
        valid: true
      }
    };

    return {
      init: function () {
        this.setPrinterListeners();
        this.setAcceptorListeners();
      },

      updatePeripheralsState: function (type, value) {
        angular.extend(peripheralsState[type], value);
        peripheralsState.productId = '*';

        $log.debug('[7Terminal.Peripherals]  update ' + type + 'state', {
          type: type,
          value: value,
          code: 'T_PERIPHERALS_STATE_UPDATE'
        });

        $rootScope.$emit('7T:Peripherals.StateChanged', peripheralsState);
      },

      getState: function () {
        return peripheralsState;
      },

      getCCStatus: function () {
        return true;
      },

      getPrinterStatus: function () {
        if (peripheralsState.printer.errorMessage) {
          return {
            message: peripheralsState.printer.errorMessage,
            type: peripheralsState.printer.statusLevel
          };
        }
        return true;
      },

      validate: function () {
        var defer = $q.defer();
        var ccStatus = this.getCCStatus();
        var printerStatus = this.getPrinterStatus();

        if (ccStatus.type === 'error') {
          defer.reject(ccStatus);
        } else if (printerStatus.type?.toLowerCase() === 'error') {
          defer.reject(printerStatus);
        } else {
          defer.resolve();
        }

        return defer.promise;
      },

      setPrinterListeners: function () {
        const printerStatusStore = usePrinterStatusStore();
        watch(
          () => printerStatusStore.printerStatusData,
          (newPrinterStatusData) => {
            const parsedData = {
              valid: newPrinterStatusData.valid,
              statusLevel: newPrinterStatusData.code,
              errorMessage: newPrinterStatusData.message
            };
            this.updatePeripheralsState('printer', parsedData);
          },
        );

        $rootScope.$on(
          '7T:Peripherals.Print',
          /**
         * @event "7T:Peripherals.Print"
         * @type {Object}
         *
         * @param event
         * @param {Object} eventData
         * @param {Object} eventData.data
         * @param {String} eventData.data.type
         * @param {String} eventData.data.action
         * @param {String} eventData.data.productId
         * @param {String} eventData.data.layoutName
         * @param {String} eventData.data.layout
         * @param {Object} eventData.data.data
         * @param {Object} eventData.data.additionalData
         * @param {Function} [eventData.data.resolve]
         * @param {Function} [eventData.data.reject]
         */
          function (event, eventData) {
            const productId = eventData.data.productId;
            const additionalData = {
              ...(eventData.data.additionalData || {})
            };
            printService.performPrint({
              info: {
                type: eventData.data.type,
                action: eventData.data.action,
                productId,
                layoutName: eventData.data.layoutName,
                layout: eventData.data.layout
              },
              data: eventData.data.data,
              additionalData
            }).then(() => {
              if (eventData.resolve) {
                eventData.resolve();
              }
            }).catch((error) => {
              $log.error('[7Terminal.Peripherals] Print failed.', {
                upstream_code: error.upstream_code,
                upstream_message: error.upstream_message,
                product_displayid: productId,
                code: 'T_INTEGRATOR_PRINT_REJECTED'
              });
              if (error.type === TPrintErrorCodes.T_PRINTER_STATUS_ERROR) {
                NabNotifications.show({
                  message: error.upstream_message,
                  type: 'error',
                  delay: 5000,
                  id: 'printer_error'
                });
              }
              if (eventData.reject) {
                eventData.reject(error);
              }
            });
          }
        );
      },
      setAcceptorListeners: function () {
        PubSub.subscribe('CoinAcceptor:moneyProcessing', function (e, data) {
          acceptorsService.showMoneyNotification(data);
          if (data.type === 'moneyProcessed') {
            userFundsService.updateBalance()
              .then((updatedBalance) => {
                $log.info('[7Terminal.Peripherals] Balance has been updated on coin acceptor processing.', {
                  code: 'T_BALANCE_UPDATE_COIN_ACCEPTOR_SUCCESS',
                  details: {
                    updatedBalance
                  }
                });
              }).catch((err) => {
                $log.error('[7Terminal.Peripherals] Failed to update balance after coin money is processed.', {
                  ...errorParser.parseUpstream(err),
                  code: 'T_BALANCE_UPDATE_FETCH_FAILED'
                });
              });
          }
        });

        PubSub.subscribe('BillAcceptor:moneyProcessing', function (e, data) {
          acceptorsService.showMoneyNotification(data);
          if (data.type === 'moneyProcessed') {
            userFundsService.updateBalance()
              .then((updatedBalance) => {
                $log.info('[7Terminal.Peripherals] Balance has been updated on bill acceptor processing.', {
                  code: 'T_BALANCE_UPDATE_BILL_ACCEPTOR_SUCCESS',
                  details: {
                    updatedBalance
                  }
                });
              }).catch((err) => {
                $log.error('[7Terminal.Peripherals] Failed to update balance after bill money is processed.', {
                  ...errorParser.parseUpstream(err),
                  code: 'T_BALANCE_UPDATE_FETCH_FAILED'
                });
              });
          }
        });
      }
    };
  }
})();
